import { render, staticRenderFns } from "./diaochaFenlei.vue?vue&type=template&id=56b19058&scoped=true"
import script from "./diaochaFenlei.vue?vue&type=script&lang=js"
export * from "./diaochaFenlei.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56b19058",
  null
  
)

export default component.exports